import React from 'react';

export default function Card(data) {
    return (

        <div className="col-sm-12 col-md-6 col-lg-4 mgb-30">
            <div className="card card-center custom-card">
                <div className="cardFrame forRdi">
                    <img style={{
                        objectFit: 'contain',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        width: '50%'
                    }} className="" src={data.image} alt="Card"/>
                </div>
                <div className="cardSet">
                    <h6 className="card-title text-secondary desc-font">{data.description.substring(0, 65)}...</h6>
                    <p className="date-format">
                        <a target="_blank" href={data.link} className="btn submitbutton mb-2 read-more-btn">Read
                            More</a>
                    </p>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/media/Card.js